import React from "react"
import { Box, Divider, Grid, Paper, Typography } from "@mui/material"
import { useContext } from "react"
import UserContext from "../../context/UserContext"

const Lizenzen = () => {
  const {
    userData: { school },
  } = useContext(UserContext)

  return (
    <Box sx={{ px: 3, pb: 1, pt: 12 }}>
      <Grid container justifyContent="space-between">
        <Grid item xs={12}>
          <Typography variant="h5" align="left" sx={{ ml: 0, color: "bmsecondary.main", mb: 1, fontWeight: 500 }}>
            Lizenzen
          </Typography>
          <Divider />
        </Grid>
      </Grid>

      <Paper sx={{ ml: 1, mt: 4, p: 2, width: "fit-content", backgroundColor: "#eee" }}>
        <Typography variant="body1" gutterBottom>
          <b>{school.name}</b> {school.isTestEnv && <i>Testumgebung</i>}
        </Typography>

        <Typography variant="body1">Gültig bis: {new Date(school.validUntil).toLocaleDateString()}</Typography>

        <Typography variant="body1">Nutzername (Schulzugang): {school.username}</Typography>

        <Typography variant="body1">
          Code zum Registrieren (Schülerzugang): <b>{school.code}</b>
        </Typography>
      </Paper>
    </Box>
  )
}

export default Lizenzen
